export default __webpack_public_path__ + "static/media/course-1.411cae70.png";